// PLAN11 WP11-08 — the browser chrome colour (<meta name="theme-color">): the Mindario v3 black band (`--band-bg`). A meta value, not a style, so it lives here and not in a .tsx
// (the no-hex guard); app/config/themeColor.test.ts reads tokens.css and fails if it drifts.
export const THEME_COLOR = "#050506";
